<template>
  <div>
    <DCardTitlebar
      v-if="layout.appearance.showsContentTitle && content.title"
      :height="layout.contentTitle.height"
      :textClass="layout.contentTitle.textClass"
      :textColor="layout.contentTitle.textColor"
      :bgColor="layout.contentTitle.bgColor"
      :divider="layout.contentTitle.divider"
      :title="content.title"
      :formatter="layout.contentTitle.formatter"
      :justify="layout.contentTitle.justify"
      :fontSize="layout.contentTitle.fontSize"
      :verticalAlign="layout.contentTitle.verticalAlign"
      :caption="content.caption"
      :captionFontSize="layout.contentTitle.captionFontSize"
      :captionTextClass="layout.contentTitle.captionTextClass"
      :captionFormatter="layout.contentTitle.captionFormatter"
    />
    <q-tab-panels animated keep-alive v-model="localValue">
      <q-tab-panel
        :name="p"
        v-for="(page, p) in content.pages"
        :key="`${content.id}-${p}`"
        class="q-px-none q-py-none no-scroll"
      >
        <DCardContentScrollArea
          :noScrolling="noScrolling"
          :behavior="behavior"
          :storePath="`pages.${p}.scrollPosition`"
          :height="scrollerHeight"
          class="sections-container"
        >
          <div
            :class="'column justify-start ' + layout.content.class"
            :style="
              layout.content.style !== undefined ? layout.content.style : ''
            "
          >
            <div
              v-for="(section, s) in page.sections"
              :class="[
                'section',
                { 'no-margin': validateNoMargin(page) || section.noMargin },
              ]"
              :key="s"
              :style="
                layout.content.style !== undefined ? layout.content.style : ''
              "
            >
              <template v-if="section.header">
                <tag
                  :is="section.header.size"
                  :style="`${
                    section.header.style !== undefined
                      ? section.header.style
                      : ''
                  }`"
                  :class="`${
                    section.header.class !== undefined
                      ? section.header.class
                      : 'q-px-md'
                  }`"
                >
                  <DDynamicText
                    v-if="section.header.text.dynamic"
                    :dynamic="section.header.text.dynamic"
                    :parentMetas="content.parentMetas"
                  />
                  <span v-else>{{ section.header.text }}</span>
                </tag>
              </template>
              <template v-if="section.body">
                <component
                  @invokeComponent="invokeComponent"
                  v-if="importedComponents.includes(section.body.type)"
                  :is="section.body.type"
                  :sectionData="section.body.data"
                  :componentId="`${content.id}-${p}`"
                  :parentMetas="content.parentMetas"
                  :id="`${content.id}-${p}`"
                  :storePath="`pages.${p}.sections.${s}.state`"
                  :behavior="behavior"
                  :scrollerHeight="scrollerHeight"
                  :layout="layout"
                  :virtualtours="content.virtualtours"
                  :pdfs="content.pdfs"
                  :currrentPage="p"
                  :componentExists="componentExists.bind(this)"
                  :cid="content.client_id ? content.client_id : content.cid"
                ></component>
                <div class="text-black" v-else>
                  {{ section.body.type }}
                </div>
              </template>
            </div>
          </div>
        </DCardContentScrollArea>
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script>
import mixin from "./d-card-mixins";
import sections from "./sections";

import DDynamicText from "./components/DDynamicText/DDynamicText.vue";
import DCardContentScrollArea from "./DCardContentScrollArea";
import DCardTitlebar from "./DCardTitlebar.vue";
sections["DCardTitlebar"] = DCardTitlebar;
sections["DCardContentScrollArea"] = DCardContentScrollArea;
sections["DDynamicText"] = DDynamicText;

export default {
  name: "DCardContent",
  mixins: [mixin],
  components: sections,
  props: {
    value: {
      type: Number,
      default: 0,
    },
    content: {
      type: Object,
      required: true,
    },
    layout: {
      type: Object,
      required: true,
    },
    scrollerHeight: {
      type: Number,
      required: true,
    },
    behavior: {
      type: String,
      requied: true,
    },
    noScrolling: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      importedComponents: [],
      insolatedComponentsWithoutMargin: ["DCarousel"],
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    this.importedComponents = this.$options.components;
    this.importedComponents = Object.keys(this.importedComponents);
  },
  methods: {
    invokeComponent(params) {
      this.$emit("invokeComponent", params);
    },
    validateNoMargin(page) {
      return (
        page.sections.length === 1 &&
        this.insolatedComponentsWithoutMargin.includes(
          page.sections[0].body.type
        )
      );
    },
    componentExists(id, component) {
      if (!this.content?.components) {
        return false;
      }

      return this.content.components.some(
        (item) => item.id === id && item.component === component
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./d-card.scss");
</style>
